import { RelatedCasesDisplayElementConfig } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCases.typings.ts";
import { WidgetProperty } from "src/dynamic-view-renderer/Widgets/Widget.typings.ts";
import { Case } from "src/types/case";
import { PageInfo } from "src/types/common";

import { useGetRelatedCasesGraphData } from "../Graph/oldLayout/old.mapping";

export const useGetIdentifiedCasesGraphData = (
  casesPage: {
    cases: Case[];
    pageInfo: PageInfo;
  } | null,
  configuration: RelatedCasesDisplayElementConfig[],
  identifier: WidgetProperty
) => {
  const cases = casesPage?.cases ?? [];
  const getRelatedCasesGraphData = useGetRelatedCasesGraphData();

  if (!getRelatedCasesGraphData) {
    return [];
  }

  return cases.flatMap((oneCase) =>
    getRelatedCasesGraphData({
      elementsConfig: configuration,
      caseInfo: {
        caseId: oneCase.id,
        propertyValues: oneCase.properties,
        elements: oneCase.elements,
      },
      options: {
        filteredIdentifiers: identifier.id ? [identifier.id] : [],
      },
    })
  );
};
